export const VIDEO_CREATIVE_CREATION_METHOD = {
    FROM_VIDEO: 'GENERATED_VIDEO',
    FROM_VAST: 'VAST',
};
export const VIDEO_CREATIVE_CREATION_METHOD_KEYS_ARRAY = Object.values(VIDEO_CREATIVE_CREATION_METHOD);
